import { computed, inject } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { CanActivateChildFn, Router } from '@angular/router'
import { filter, map, take } from 'rxjs/operators'
import { environment } from '@env'
import { ProfileStore } from '@core/store/profile/profile.store'

export const roleGuard: CanActivateChildFn = (_route, state) => {
  const router = inject(Router)
  const profileStore = inject(ProfileStore)

  return toObservable(computed(() => profileStore.isPageAllowed(state.url))).pipe(
    filter((allowed): allowed is boolean => typeof allowed === 'boolean'),
    take(1),
    map((allowed) => {
      if (state.url !== environment.NOT_PERMITTED_URL && !allowed) {
        return router.parseUrl(environment.NOT_PERMITTED_URL)
      }
      return true
    }),
  )
}
